import UserFeedCard from './UserFeedCard';
import { AppPaths } from "../../utils/AppPaths";
import { useNavigate } from "react-router-dom";



const Feeds = ({ feedData, coachMarkStep }: { feedData: any[]; coachMarkStep?: number }) => {
  const navigate = useNavigate();
  const challenge = feedData?.[0];
  const challengeType = challenge?.type;
  const challengeFeeds = challenge?.feeds || [];
  const showSeeAll = Number(challenge?.feedCount) > 2;

  const normalizedFeeds = challengeFeeds.map((feed: any) => ({
    ...feed,
    challengeId: {
      _id: challenge?._id,
      title: challenge?.title,
      type: challengeType,
    },
  }));

  if (!challenge) {
    return null;
  }

    const handleChallenge = (type: string, id: string) => {
    if (type === 'text') {
        navigate(`${AppPaths.DANCE_CHALLENGE}?id=${id}`)
    } else if (type === 'image' || type === 'video') {
        navigate(`${AppPaths.HALLOWEEN_CHALLENGE}?id=${id}&type=${type}`)
    } else {
        navigate(`${AppPaths.FALLFUN_QUIZ_CHALLENGE}?id=${id}`)
    }
    }

  return (
    <div className={`min-h-screens coach-view-house-feed ${
                coachMarkStep === 6 ? "coach-view-house-feed-highlight" : ""}`}>

      <section className="mb-6">
        <div className="px-3 py-1">
          <h2 className="inter-16-regular cursor-pointer" onClick={() => handleChallenge(challengeType, challenge?._id)}>{challenge?.title}</h2>
        </div>
        
        <div className="divide-y divide-gray-100">
          {normalizedFeeds.map((post: any) => (
            <UserFeedCard 
              key={post._id} 
              type={challengeType} 
              data={post} 
            />
          ))}
        </div>
        
        {showSeeAll && (
          <div className="px-4 pt-2">
            <button
              type="button"
              className="inline-flex items-center gap-1 rounded-full bg-[#DADADA] px-2 inter-12-bold text-[#231F20]" style={{paddingTop: 3, paddingBottom: 2}}
              onClick={() => handleChallenge(challengeType, challenge?._id)}
            >
              <span aria-hidden="true">🔎</span>
              <span>See All</span>
            </button>
          </div>
        )}
      </section>

    </div>
  );
};

export default Feeds;